<script lang="ts">
    import SignaturePad from 'signature_pad'
    import { createEventDispatcher, onMount } from 'svelte'

    export let image: string = ''
    export let label: string = ''
    export let background: string = '#ffffff'
    export let color: string = '#000000'

    let dispatch = createEventDispatcher()

    let root
    let canvas

    let signaturePad
    onMount(() => {
        signaturePad = new SignaturePad(canvas, {
            backgroundColor: 'rgba(0,0,0,0)',
            penColor: color,
        })

        signaturePad.addEventListener('endStroke', () => {
            image = signaturePad.toDataURL('image/svg+xml')
            dispatch('change')
            console.log('image', image.length, image)
        })
        try {
            canvas.width = root.offsetWidth
            canvas.height = root.offsetHeight
        } catch (error) {}

        window.addEventListener('resize', resizeCanvas)
        resizeCanvas()
    })
    function clear() {
        signaturePad.clear()
        image = ''
        dispatch('change')
    }

    function resizeCanvas() {
        // When zoomed out to less than 100%, for some very strange reason,
        // some browsers report devicePixelRatio as less than 1
        // and only part of the canvas is cleared then.
        try {
            var ratio = Math.max(window.devicePixelRatio || 1, 1)
            canvas.width = canvas.offsetWidth * ratio
            canvas.height = canvas.offsetHeight * ratio
            canvas.getContext('2d').scale(ratio, ratio)
        } catch (error) {}
    }
</script>

<div bind:this={root} class="root">
    <div class="wrapper" style="background:{background};">
        <canvas bind:this={canvas} id="signature-pad" class="signature-pad" />
    </div>
    <div class="label" style="color:{color}">{label}</div>
    <button class="button" style="color:{color}" on:click={clear}>Limpar</button>
</div>

<style>
    .wrapper {
        position: relative;
        width: 315px !important;
        height: 180px !important;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
        border-radius: 4px;
        overflow: hidden;
    }
    .signature-pad {
        position: absolute;
        left: 0;
        top: 0;
        /* O dedo aqui desenha, nunca rola nem dá zoom. Sem isto o navegador trata o arrasto como
           gesto de página e o traço sai picotado (recomendação do próprio SignaturePad). */
        touch-action: none;
        width: 315px !important;
        height: 180px !important;
        background-color: white;
        border: 1px solid #99999980;
    }

    .root {
        position: relative;
    }
    .label {
        position: absolute;
        top: 0px;
        left: 0px;
        padding-left: 4px;
        pointer-events: none;
    }
    .button {
        width: 100%;
        max-width: 65px;
        padding: 2px;
        background-color: #99999910;
        position: absolute;
        bottom: 0px;
        left: 0px;
        margin: 0px;
        border-bottom-left-radius: 4px;
    }
</style>
